module.exports = __webpack_public_path__ + "svg/prospeneo-logo-light.176a8919.svg";